import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../redux/auth-store";

const AuthLock: React.FC<{
  children: React.ReactNode;
  adminOnly?: boolean;
}> = ({ children, adminOnly = false }) => {
  const { user, token: authToken } = useAuthStore();

  if (!authToken) {
    return <Navigate to={"/login"} replace />;
  }

  if (adminOnly && user?.role_id !== 1) {
    return <Navigate to={"/"} replace />;
  }

  return <>{children}</>;
};

export default AuthLock;
